module.exports = __webpack_public_path__ + "img/1722479549541-image.jpg.ad5ab437.webp";